import {VideoSlidesStreamJackpotValueDefaultBox} from "./video-slides-stream-jackpot-value-default.box";

export const VideoSlidesStreamJackpotValueBox = VideoSlidesStreamJackpotValueDefaultBox;